__turbopack_context__.v({
  "container": "UGCHighlightSection-module__x3xEaq__container",
  "subtitle": "UGCHighlightSection-module__x3xEaq__subtitle",
  "titleWrapper": "UGCHighlightSection-module__x3xEaq__titleWrapper",
});
